import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 flex items-center justify-center z-50" }
const _hoisted_2 = { class: "bg-gray-800 text-white rounded-lg shadow-xl border border-gray-700 p-5 max-w-md z-10 w-full mx-4 md:w-auto" }
const _hoisted_3 = { class: "flex justify-between items-start mb-4" }
const _hoisted_4 = { class: "bg-red-900 bg-opacity-20 p-3 rounded-lg mb-4" }
const _hoisted_5 = { class: "text-base text-gray-100" }
const _hoisted_6 = { class: "font-semibold text-white" }
const _hoisted_7 = { class: "flex justify-end space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-lg font-medium text-red-400" }, "Blokiraj korisnika", -1)),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          class: "text-gray-400 hover:text-gray-300 transition-colors"
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            class: "h-5 w-5",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
              "clip-rule": "evenodd"
            })
          ], -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          _cache[5] || (_cache[5] = _createTextVNode(" Da li ste sigurni da želite da blokirate korisnika ")),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.otherUser?.username), 1),
          _cache[6] || (_cache[6] = _createTextVNode("? "))
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-sm text-gray-300 mb-4" }, " Nakon blokiranja, nećete više moći da komunicirate sa ovim korisnikom. Ova akcija je trajna i može se poništiti samo kontaktiranjem administratora sajta putem email-a. ", -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
          class: "px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-500 transition-colors"
        }, " Odustani "),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('confirm'))),
          class: "px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
        }, " Blokiraj ")
      ])
    ])
  ]))
}